//import 'bootstrap';
$(document).ready(() => {
  const hamb = document.querySelector("#hamb");
  const mainNav = document.querySelector("#main-nav");
  const overlay = document.querySelector("#overlay");
  const closeMenuBtn = document.querySelector("#close-menu");

  const searchBtn = document.querySelector("#search-btn");
  const mobileSearchBtn = document.querySelector("#mobile-search-btn");
  const mobileSearch = document.querySelector("#mobile-search");
  const closeSearchBtn = document.querySelector("#close-search-btn");
  const searchModal = document.querySelector("#search-modal");
  let menuIsOpen = false,
    mobileSearchIsOpen = false;

  //hide header on scroll down
  let lastScroll = window?.pageYOffset || 0;
  function handleHeaderEffect() {
    let scrolly = window.pageYOffset;
    const hdr = document.querySelector("header");
    if (scrolly > 100) {
      if (window.pageYOffset > lastScroll) {
        hdr.style.transform = "translateY(-125%)";
      } else {
        hdr.style.transform = "translateY(0px)";
      }
    } else {
      hdr.style.transform = "translateY(0px)";
    }

    // dropshadow
    if (scrolly > 200) {
      hdr.classList.add("shadow");
    } else {
      hdr.classList.remove("shadow");
    }

    lastScroll = scrolly;
  }
  handleHeaderEffect();
  window.addEventListener("scroll", handleHeaderEffect);

  hamb.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      console.log("clicked hamburger");
      if (menuIsOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    },
    false
  );

  closeMenuBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeMenu();
    },
    false
  );

  searchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openSearch();
      searchBtn.classList.remove("bg-darkblue");
      searchBtn.classList.add("bg-blue");
    },
    false
  );

  // closeSearchBtn.addEventListener(
  //   "click",
  //   function (e) {
  //     e.stopPropagation();
  //     closeSearch();
  //   },
  //   false
  // );

  // opens the search
  function openSearch() {
    console.log("opensearch function");
    searchModal.classList.remove("hidden");

    searchModal.querySelector("input").focus();
  }

  // closes the search
  function closeSearch() {
    searchModal.classList.add("hidden");
    searchModal.querySelector("input").blur();
    searchBtn.classList.remove("bg-blue");
    searchBtn.classList.add("bg-darkblue");
  }

  mobileSearchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      if (mobileSearchIsOpen) {
        closeMobileSearch();
      } else {
        openMobileSearch();
      }
    },
    false
  );
  function openMobileSearch() {
    const msbClasses = ["bg-white", "text-darkblue", "text-white", "bg-blue"];
    msbClasses.forEach((className) => {
      mobileSearchBtn.classList.toggle(className);
    });
    mobileSearch.classList.remove("hidden");
    document.querySelector("#mobile-search input").focus();
    mobileSearchIsOpen = true;
  }
  function closeMobileSearch() {
    const msbClasses = ["bg-white", "text-darkblue", "text-white", "bg-blue"];
    msbClasses.forEach((className) => {
      mobileSearchBtn.classList.toggle(className);
    });
    mobileSearch.classList.add("hidden");
    document.querySelector("#mobile-search input").blur();
    mobileSearchIsOpen = false;
  }
  // opens main nav
  function openMenu() {
    menuIsOpen = true;
    console.log("opening nav");
    mainNav.classList.add("open");
    //overlay.classList.remove("hidden");
  }

  // closes main nav
  function closeMenu() {
    menuIsOpen = false;
    closeMobileSearch();
    console.log("closing nav");
    mainNav.classList.remove("open");
    //overlay.classList.add("hidden");
  }

  // on mobile each dropdown group has an overview link
  function createOverviewLinks() {
    const parentMenuItems = document.querySelectorAll(
      ".menu-header-menu-container .menu-item-has-children"
    );
    parentMenuItems.forEach((item) => {
      const classes = [];
      const link = item.querySelector("a").href;
      const li = document.createElement("li");
      li.classList.add("depth-1", "menu-item", "overview-link");
      if (item.classList.contains("current-menu-item")) {
        li.classList.add("current-menu-item");
      }
      const a = document.createElement("a");
      a.href = link;
      a.innerText = "Overview";
      a.classList.add("dropdown-item");
      li.appendChild(a);
      item.querySelector("ul").prepend(li);
    });
  }
  // // dont need this anymore
  // createOverviewLinks();

  // animate on scroll library
  AOS.init();

  var dropdowns = document.querySelectorAll(".dropdown");
  var viewportWidth = $(window).width();
  console.log(viewportWidth);

  $("body").click(function () {
    closeSearch();
    closeAllDropDowns();
  });

  searchModal.addEventListener("click", function (e) {
    e.stopPropagation();
  });
  $(window).scroll(function () {
    if (viewportWidth <= 1023) {
      closeMenu();
      return;
    } else {
      closeSearch();
      closeAllDropDowns();
    }
  });

  // $('#searchHolderDesktop button').click(function (e) {
  //     e.stopPropagation()
  //     openSearch();
  // });

  // $('#searchHolderDesktop form').click(function (e) {
  //     e.stopPropagation()
  //     //openSearch();
  // });

  // function openSearch() {
  //     $('#searchHolderDesktop').addClass('active')
  //     $('#searchHolderDesktop form input.search-field').focus()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).addClass('hidden')
  //     })
  // }

  // function closeSearch() {
  //     $('#searchHolderDesktop').removeClass('active');
  //     $('#searchHolderDesktop form input.search-field').blur()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).removeClass('hidden')
  //     })
  // }

  function closeAllDropDowns() {
    $("header").removeClass("active");
    $(".underlay").removeClass("active");
    $(dropdowns).each(function () {
      $(this).removeClass("open");
    });
  }

  // we dont want to close menus, etc.. when focusing on the search input on mobile devices
  let width = window.innerWidth;
  let height = window.innerHeight;

  window.addEventListener("resize", function () {
    let newWidth = window.innerWidth;
    let newHeight = window.innerHeight;
    if (newWidth !== width) {
      onWidthResize();
    }

    width = newWidth;
    height = newHeight;
  });

  function onWidthResize() {
    closeAllDropDowns();
    closeMenu();
    closeMobileSearch();
    closeSearch();
    viewportWidth = $(window).width();
    console.log(viewportWidth);
  }

  // on resize, reset this wiewport width
  // window.addEventListener( "resize", function () {
  //   closeAllDropDowns();
  //   closeMenu();
  //   closeMobileSearch();
  //   closeSearch();
  //   viewportWidth = $( window ).width();
  //   console.log( viewportWidth );
  // } );

  $("header .dropdown a.main-item").click(function (e) {
    if (viewportWidth > 1023) return;
    e.stopPropagation();

    if ($(this).parent().hasClass("open")) {
      console.log("navigating");
    } else {
      e.preventDefault();
      closeAllDropDowns();
      $(this).parent().addClass("open");
    }
  });

  $("header .dropdown a").click(function (e) {
    e.stopPropagation();
  });
  $("header .dropdown").mouseenter(function () {
    if (viewportWidth <= 1023) return;
    closeAllDropDowns();
    $("header").addClass("active");
    $(".underlay").addClass("active");
    $(this).addClass("open");
  });
});

// floating labels for gform inputs with top label
// $(
//   "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
// ).on("focus", function () {
//   console.log("focusing");
//   $(this).parent().parent(".gfield").addClass("active");
// });

// $(
//   "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
// ).on("blur", function () {
//   if ($(this).val().length == 0) {
//     $(this).parent().parent(".gfield").removeClass("active");
//   }
// });

// $(
//   "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
// ).each(function () {
//   if ($(this).val().length > 0) {
//     console.log("adding class active to input", $(this).val());
//     $(this).parent().parent(".gfield").addClass("active");
//   }
// });
